import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { IResourceListItem } from './Models';
import { Dialog, DialogActions, DialogTitle, DialogContent, Button, Icon, DialogContentText } from '@material-ui/core';
import axios from 'axios';

interface IFindResourceResult {
	LogId: number,
	Name: string,
	Type: string,
	Kind: number,

	ErrorMessage: string,
}

interface IProps {
	kind: string,
	onSave: (r: IResourceListItem) => void,
	isModal: boolean,
	className: string,
	disabled: boolean,
}

export default function SearchButton(props: IProps) {
	const { t } = useTranslation();

	const [errorMessage, setErrorMessage] = React.useState("");
	const [loading, setLoading] = React.useState(false);
	const [show, setShow] = React.useState(false);

	let clientIpId = "CreatedFrom_ClientIp";
	var computerNameId = "CreatedFrom_ComputerName";
	if (props.isModal) {
		clientIpId = "workflow_CreatedFrom_ClientIp";
		computerNameId = "workflow_CreatedFrom_ComputerName";
	}

	React.useEffect(() => {
		let clientIpInput = document.getElementById(clientIpId) as HTMLInputElement;
		let computerNameInput = document.getElementById(computerNameId) as HTMLInputElement;
		let hasInputs = !!clientIpInput && !!computerNameInput;
		if (!hasInputs) {
			setShow(false);
			console.warn("Not found input '" + clientIpId + "'")
			return;
		}
		loadCreatedFromComputerName(computerNameInput);
	}, []);

	function loadCreatedFromComputerName(computerNameInput: HTMLInputElement) {
		if (!computerNameInput) {
			console.warn("Not found input '" + {clientIpId} + "'")
			return;
		}
		
		let notLoaded = !computerNameInput.value;
		let $ = (window as any).$;

		if (notLoaded) {
			load($.support.cors ? 'text' : 'jsonp'); // CORS: Chrome/FF/IE10, JSONP: IE<10
		} else {
			setShow(!!computerNameInput.value);
		}
		
		function load(type) {
			let qdesk = (window as any).qdesk;
			if (!qdesk.getComputerNameUrl) {
				return;
			};
			let rootModal = document.getElementById("ajax-workflow-modal");
			if (!rootModal || rootModal.dataset.isTransient != "True") {
				return;
			}

			$.ajax({
				url: qdesk.getComputerNameUrl,
				dataType: type,
				success: (data: string) => {
					computerNameInput.value = data || '?Returned empty string';
					setShow(!!data);
				},
				error: (xhr, status, error) => {
					console.warn(status, error);
					if (shouldTryJsonp(error)) load('jsonp');
					else computerNameInput.value = '?' + error;
				}
			});

			function shouldTryJsonp(error) {
				// IE10: CORS czasem zwraca AccessDenied (np. inna "strefa"), wtedy przechodzimy na JSONP
				return (type != 'jsonp') && (error && error.number == -2147024891);
			}
		}
	};

	function handleClick() {

		let clientIpInput = document.getElementById(clientIpId) as HTMLInputElement;
		let computerNameInput = document.getElementById(computerNameId) as HTMLInputElement;

		if (!clientIpInput) {
			let error = `The item could not be found '${clientIpId}'.`;
			console.warn(error);
			setErrorMessage(error);
			return;
		}
		if (!computerNameInput) {
			let error = `The item could not be found '${computerNameId}'.`;
			console.warn(error);
			setErrorMessage(error);
			return;
		}

		setLoading(true)
		axios.get<IFindResourceResult>('/Resources/FindResource/', {
			params: {
				ClientIp: clientIpInput.value,
				ComputerName: computerNameInput.value,
			}
		})
			.then(r => {
				setLoading(false);
				if (r.data.ErrorMessage) {
					setErrorMessage(r.data.ErrorMessage);
				}
				else {
					props.onSave({
						KindEnum: r.data.Kind,
						Id: r.data.LogId,
						Type: r.data.Type,
						Name: r.data.Name,

						AcceptantId: null,
						ApplicationName: null,
						BarCode: null,
						Category: null,
						Company: null,
						Department: null,
						EmployeeCompany: null,
						EmployeeId: null,
						EmployeeName: null,
						GivenName: null,
						HRId: null,
						Kind: null,
						Manufacturer: null,
						Model: null,
						MpkNumber: null,
						ReferenceNumber: null,
						Relation: null,
						RelationId: null,
						ReplacementDate: null,
						SAPId: null,
						Selected: null,
						SerialNumber: null,
						Status: null,
						STNumber: null,
						Surname: null,
						UsageType: null,
						IssueId: null,
						Email: null,
					});
				}
			})
			.catch(r => {
				console.error(r);
				setErrorMessage("Nieoczekiwany problem.");
				setLoading(false);
			});
	}

	if (!show || props.kind) {
		return null;
	}

	return <>
		<Button
			className={props.className}
			variant="outlined"
			onClick={handleClick}
			startIcon={<Icon>add_circle</Icon>}
			disabled={loading || props.disabled}
		>
			{t("control.resources.addThisComputer")}
		</Button>
		{errorMessage && <Dialog
			open={true}
			onClose={() => setErrorMessage("")}
		>
			<DialogTitle>{t("common.error")}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{errorMessage}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setErrorMessage("")} color="secondary" variant="contained" autoFocus>
					{t("common.action.ok")}
				</Button>
			</DialogActions>
		</Dialog>}
	</>
}
